import React, { useState } from 'react';

import { TableCell, Tooltip } from '@material-ui/core';
import TableRow from '@material-ui/core/TableRow';

import { UiButton } from '../../../../ui/ui-button';

import { employeeNameFromSimpleContact } from '../../../../employees/utils/employee-name';
import { ICON_NAMES, MaterialDesignIcon } from '../../../../util/material-design-icons';

type InputProps = {
  messageDetail: AnnouncementDeliverabilityDetail;
  retryMessage: (handleRetrySendMessage: AnnouncementDeliverabilityDetail) => Promise<boolean>;
};

export const LegacyFailedMessageRow = (props: InputProps) => {
  const { messageDetail, retryMessage } = props;

  const [messageResent, setMessageResent] = useState<boolean>(false);

  const handleRetrySendMessage = async () => {
    if (!messageResent) {
      const sentMessage = await retryMessage(messageDetail);
      setMessageResent(sentMessage);
    }
  };

  return (
    <TableRow>
      <TableCell className="u-width-10">
        <Tooltip title="Message was not delivered. Click to retry.">
          <MaterialDesignIcon
            iconName={ICON_NAMES.REPLAY}
            size="sm"
            onClick={handleRetrySendMessage}
          />
        </Tooltip>
      </TableCell>
      <TableCell colSpan={2} className="u-width-70">
        {employeeNameFromSimpleContact({
          nickname: messageDetail.nickname,
          firstName: messageDetail.firstName,
          lastName: messageDetail.lastName,
        })}
      </TableCell>
      <TableCell className="u-width-20">
        <UiButton
          disabled={messageResent}
          size="xs"
          variant="secondary"
          onClick={handleRetrySendMessage}
        >
          Retry
        </UiButton>
      </TableCell>
    </TableRow>
  );
};
